import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-4" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "member-id" }, [
  /*#__PURE__*/_createTextVNode(" Member ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_6 = { class: "col-12 col-md-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "group-name" }, " Group Name ", -1 /* HOISTED */)
const _hoisted_9 = { class: "col-12 col-md-4" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Group ID ", -1 /* HOISTED */)
const _hoisted_12 = { class: "col-12 col-md-4" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-insured" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship to Insured", -1 /* HOISTED */)
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = { class: "col-12 col-md-4" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Case Manager ", -1 /* HOISTED */)
const _hoisted_21 = { class: "col-12 col-md-4" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "employer-name" }, " Employer Name ", -1 /* HOISTED */)
const _hoisted_24 = { class: "col-12 col-md-4" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "subs-first-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_27 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_28 = { class: "col-12 col-md-4" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "subs-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_32 = { class: "col-12 col-md-4" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "deductible-amount" }, " Deductible Amount ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-amount" }, " Out-of-Pocket Amount ", -1 /* HOISTED */)
const _hoisted_37 = { class: "col-12 col-md-4" }
const _hoisted_38 = { class: "form-group d-flex flex-row justify-content-between" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "has-deductible-met",
  class: "me-2"
}, " Deductible Met ", -1 /* HOISTED */)
const _hoisted_40 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-met" }, " Out-of-Pocket Met ", -1 /* HOISTED */)
const _hoisted_49 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  name: "out-of-pocket-met",
  autocomplete: "off",
  hidden: ""
}, null, -1 /* HOISTED */)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  name: "out-of-pocket-met",
  autocomplete: "off",
  hidden: ""
}, null, -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "col-12 col-md-4" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Copay Amount ", -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\"><label for=\"coinsurance\">Coinsurance Amount</label><div class=\"d-flex flex-row\"><div class=\"form-check custom-radio\"><input type=\"radio\" id=\"dollar-amount\" name=\"coinsurance\" class=\"form-check-input\" value=\"false\"><label class=\"form-check-label\" for=\"dollar-amount\"><span class=\"me-1\">Dollar Amount</span></label></div><div class=\"form-check custom-radio ps-4 ms-4\"><input type=\"radio\" id=\"percentage\" name=\"coinsurance\" class=\"form-check-input\" value=\"true\"><label class=\"form-check-label\" for=\"percentage\"><span class=\"me-1\">Percentage</span></label></div></div></div>", 1)
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "coinsurance-amount" }, " Coinsurance Amount ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["form-control", `${!_ctx.v$.payer.MemberId.$error ? '' : 'field-invalid'}`]),
          maxlength: "50",
          name: "member-id",
          type: "text",
          placeholder: "Enter Member ID",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payer.MemberId) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.MemberId.$touch && _ctx.v$.payer.MemberId.$touch(...args)))
        }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
          [_vModelText, _ctx.payer.MemberId]
        ]),
        (_ctx.v$.payer.MemberId.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Member Id is required."))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-name",
          type: "text",
          placeholder: "Enter Group Name",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payer.GroupName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.GroupName]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Group ID",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payer.GroupId) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.GroupId]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("select", {
          class: _normalizeClass(["form-select", `${!_ctx.v$.payer.RelationshipToInsured.$error ? '' : 'field-invalid'}`]),
          name: "relationship-to-insured",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payer.RelationshipToInsured) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.RelationshipToInsured.$touch && _ctx.v$.payer.RelationshipToInsured.$touch(...args)))
        }, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.relationshipToInsuredEnum), ([key, value]) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: value.value
            }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_16))
          }), 128 /* KEYED_FRAGMENT */))
        ], 34 /* CLASS, HYDRATE_EVENTS */), [
          [_vModelSelect, _ctx.payer.RelationshipToInsured]
        ]),
        (_ctx.v$.payer.RelationshipToInsured.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Relationship is required."))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Case Manager",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payer.CaseManager) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.CaseManager]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "employer-name",
          type: "text",
          placeholder: "Enter Employer Name",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payer.EmployerName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.EmployerName]
        ])
      ])
    ]),
    (_ctx.showSubscriberName)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", `${!_ctx.v$.payer.SubscriberFirstName.$error ? '' : 'field-invalid'}`]),
                name: "subs-first-name",
                type: "text",
                placeholder: "Enter Subscriber First Name",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payer.SubscriberFirstName) = $event)),
                onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.SubscriberFirstName.$touch && _ctx.v$.payer.SubscriberFirstName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.payer.SubscriberFirstName]
              ]),
              (_ctx.v$.payer.SubscriberFirstName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Subscriber First Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", `${!_ctx.v$.payer.SubscriberLastName.$error ? '' : 'field-invalid'}`]),
                name: "subs-last-name",
                type: "text",
                placeholder: "Enter Subscriber Last Name",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payer.SubscriberLastName) = $event)),
                onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.SubscriberLastName.$touch && _ctx.v$.payer.SubscriberLastName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.payer.SubscriberLastName]
              ]),
              (_ctx.v$.payer.SubscriberLastName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Subscriber Last Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "deductible-amount",
          type: "text",
          placeholder: "Enter Deductible Amount",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payer.DeductibleAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.DeductibleAmount],
          [_directive_number_only]
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "out-of-pocket-amount",
          type: "text",
          placeholder: "Enter Out-of-Pocket Amount",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payer.OutOfPocketMaxAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.OutOfPocketMaxAmount]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", null, [
          _hoisted_39,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", {
                class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.DeductibleMet ? 'active' : ''}`),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hasDeductibleMetChanged(true)))
              }, _hoisted_43, 2 /* CLASS */),
              _createElementVNode("label", {
                class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.DeductibleMet ? '' : 'active'}`),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hasDeductibleMetChanged(false)))
              }, _hoisted_46, 2 /* CLASS */)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("label", {
              class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.IsOutOfPocketMaxMet ? 'active' : ''}`),
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(true)))
            }, _hoisted_52, 2 /* CLASS */),
            _createElementVNode("label", {
              class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.IsOutOfPocketMaxMet ? '' : 'active'}`),
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(false)))
            }, _hoisted_55, 2 /* CLASS */)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _hoisted_58,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "copay-amount",
          type: "text",
          placeholder: "Enter Copay Amount",
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.payer.CopayAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.CopayAmount]
        ])
      ]),
      _hoisted_59,
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "coinsurance-amount",
          type: "text",
          placeholder: "Enter Coinsurance Amount",
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.payer.CoinsuranceAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.CoinsuranceAmount]
        ])
      ])
    ])
  ]))
}